import * as React from "react";
import type {} from "@mui/x-charts/themeAugmentation";
import type {} from "@mui/x-tree-view/themeAugmentation";
import {alpha} from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Header from "./Header";
import {useOutlet} from "react-router-dom";
import SideMenu from "./SideMenu";
import AppTheme from "@/theme/AppTheme";
import DrawerModal from "@/widget/DrawerModal/DrawerModal";
import DialogModal from "@/widget/DialogModal/DialogModal";
import Copyright from "@/widget/Internals/Copyright";
import {chartsCustomizations, dataGridCustomizations, inputsCustomizations, navigationCustomizations, treeViewCustomizations} from "@/theme/customizations";


const xThemeComponents = {
    ...chartsCustomizations,
    ...dataGridCustomizations,
    ...treeViewCustomizations,
    ...inputsCustomizations,
    ...navigationCustomizations
};

export default function Layout() {
    const outlet = useOutlet();

    return (
        <AppTheme themeComponents={xThemeComponents}>
            <CssBaseline enableColorScheme/>
            <Box sx={{display: "flex"}}>
                <SideMenu/>
                <Box
                    component="main"
                    sx={(theme) => ({
                        flexGrow: 1,
                        backgroundColor: theme.vars
                            ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
                            : alpha(theme.palette.background.default, 1),
                        overflow: "auto",
                    })}
                >
                    <Stack
                        spacing={2.8}
                        sx={{
                            alignItems: "center",
                            mr: 2.6,
                            ml: 3,
                            // pb: 5,
                            mt: {xs: 8, md: 0},
                        }}
                    >
                        <Header/>
                        {outlet}
                        <Copyright sx={{pb: 3}}/>
                    </Stack>
                </Box>
            </Box>
            <DrawerModal/>
            <DialogModal/>
        </AppTheme>
    );
}
